import React, { useRef } from 'react';
// @ts-ignore
import styles from './CalendarTermPicker.module.scss';
import Modal from '../Modal/Modal';
// @ts-ignore
import moment from 'moment';
import CalendarAbsenceEvent from './CalendarAbsenceEvent';

interface CalendarAbsenceEventModalProps {
	opened: boolean;
	onClose: any;
	selectedDate: any;
	defaultData?: any;
	params?: any;
	loggedUserId?: string;
}

export default function CalendarAbsenceEventModal(
	props: CalendarAbsenceEventModalProps,
) {
	const { opened, onClose, selectedDate, loggedUserId, defaultData, params } =
		props;

	return (
		<div className={styles.wrapper}>
			<Modal opened={opened} onClose={onClose}>
				<Modal.Header
					title={defaultData ? 'base.editAbsence' : 'base.createAbsence'}
				/>
				<Modal.Content contentScroll={true}>
					<CalendarAbsenceEvent
						order={defaultData}
						selectedDate={selectedDate}
						onSuccess={onClose}
						loggedUserId={loggedUserId}
						params={params}
					/>
				</Modal.Content>
			</Modal>
		</div>
	);
}
